require('./footer-control-bar/footer-control-bar.scss');
var Button = require('treeline-shared-components/button.js');
var CartLocationDisplay = require('./cart/cart-location-display');
var ShoppingCartIndicator = require('./cart/shopping-cart-indicator');
var SpinnerButton = require('treeline-shared-components/spinner-button');
var BaseViews = require('./base');
var StringUtils = require('../utils/strings');

var FooterControlBar = BaseViews.LayoutView.extend({
    _expandedMap: false,
    template: require('./footer-control-bar/footer-control-bar.html'),
    className: 'fmcy-footer-control-bar fmcy-plugin-bootstrap container-fluid',
    initialize: function (options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
                _appChannel: null,
                _menuState: null,
                theme: 'dark' // light
            }
        );

        this.options._appChannel.on('cart:display:errors', function () {
          self._reActivateShoppingCartActionButton();
        });
    },
    ui : {
      leftColumn: '#fmcy-footer-bar-left-column',
      rightColumn: '#fmcy-footer-bar-right-column'
    },
    regions : {
      shoppingCartRightRegion: '.fmcy-footer-bar-right-region',
      shoppingCartLeftRegion: '.fmcy-footer-bar-left-region'
    },
    hide: function () {
      this.$el.hide();
    },
    show: function () {
      this.$el.show();
    },
    _renderCartLocationDisplay: function () {
        this._cartLocationDisplay = new CartLocationDisplay({
          _appChannel: this.options._appChannel
        });
        this.shoppingCartLeftRegion.show(this._cartLocationDisplay);
    },
    _clearLeftRegion: function () {
      this.shoppingCartLeftRegion.empty();
    },
    _renderCheckoutActionButton: function () {
      var self = this;
      var checkoutButton = new SpinnerButton.SpinnerButton({
          label: 'CHECK OUT',
          enabled: true,
          theme: Button.THEMES.PRIMARY,
          onClickedCallback: function () {
            self.options._appChannel.trigger('cart:view');
          }
      });
      this.shoppingCartRightRegion.show(checkoutButton);
    },
    _renderShoppingCartBackCancelButton: function (label, action, cancelButtonLocation) {
      var self = this;
      this.shoppingCartBackCancelButton = new SpinnerButton.SpinnerButton({
          label: label,
          enabled: true,
          theme: Button.THEMES.PRIMARY,
          classNames: 'cancel-button',
          onClickedCallback: function () {
            self.shoppingCartBackCancelButton.toggleSpinner(true);
            self.shoppingCartBackCancelButton.toggledEnabledState(false);
            self.options._appChannel.trigger(action);
          }
      });

      if (cancelButtonLocation == 'right') {
        this.shoppingCartRightRegion.show(this.shoppingCartBackCancelButton);
      } else {
        this.shoppingCartLeftRegion.show(this.shoppingCartBackCancelButton);
      }

    },
    _renderShoppingCartActionButton: function (label, action) {
      var self = this;
      this.shoppingCartActionButton = new SpinnerButton.SpinnerButton({
          label: label,
          enabled: true,
          theme: Button.THEMES.PRIMARY,
          onClickedCallback: function () {
            self.shoppingCartActionButton.toggleSpinner(true);
            self.shoppingCartActionButton.toggledEnabledState(false);
            self.options._appChannel.trigger(action);
          }
      });
      this.shoppingCartRightRegion.show(this.shoppingCartActionButton);
    },
    _reActivateShoppingCartActionButton: function () {
      if (this.shoppingCartActionButton) {
        this.shoppingCartActionButton.toggleSpinner(false);
        this.shoppingCartActionButton.toggledEnabledState(true);
      }
    },
    _renderShoppingCartIndicator: function () {
      this._shoppingCartIndicator = new ShoppingCartIndicator({
        _appChannel: this.options._appChannel,
        style: 'expanded',
        cartCount: this.options._appChannel.request('cart:get:items:count')
      });
      this.shoppingCartLeftRegion.show(this._shoppingCartIndicator);
    },
    _clearRightRegion: function () {
      this.shoppingCartRightRegion.empty();
    },
    _shouldMakeRightColumnFillScreen: function () {
      if ($(window).width() < 992) {
        return true;
      } else {
        return false;
      }
    },
    _setColumnCss: function (columns) {
      this.ui.leftColumn.removeClass();
      this.ui.rightColumn.removeClass();
      if (columns == 2) {
        this.ui.leftColumn.addClass('col-xs-6');
        this.ui.rightColumn.addClass('col-xs-6');
      } else {
        this.ui.leftColumn.addClass('col-xs-0 col-md-6');
        this.ui.rightColumn.addClass('col-xs-12 col-md-6');
      }
    },
    _updateDisplayState: function () {
      var self = this;

      self._clearRightRegion();
      self._clearLeftRegion();
      self._setColumnCss(2);

      if (self.options._appChannel.request('active:view:check', 'reviewCart') &&
      self.options._appChannel.request('active:view:check', 'orderSuccess')) {
        self._renderCartLocationDisplay();
        self.show();
        $(document.body).addClass('fmcy-showing-footer-controlbar');
      } else if (self.options._appChannel.request('active:view:check', 'reviewCart')) {

        var cancelButtonLocation = 'right';
        if (self.options._appChannel.request('cart:get:items:count') > 0) {
          cancelButtonLocation = 'left';
          self._renderShoppingCartActionButton('COMPLETE ORDER', 'cart:validate');
        }

        if ($(window).width() >= 460) {
          self._renderShoppingCartBackCancelButton('CONTINUE SHOPPING', 'cart:close', cancelButtonLocation);
        } else {
          self._renderShoppingCartBackCancelButton('BACK', 'cart:close', cancelButtonLocation);
        }

        self.show();
        $(document.body).addClass('fmcy-showing-footer-controlbar');
      } else if (self.options._appChannel.request('active:view:check', 'paymentCart')) {
        self.currentOrderModel = this.options._appChannel.request('cart:get:curent:order');
        if (self.currentOrderModel && self.currentOrderModel.has('order_total')) {
          self.cartCost = self.currentOrderModel.get('order_total');
          self._renderShoppingCartActionButton('<i class="glyphicon glyphicon-lock"></i> PAY ' + StringUtils.currency(self.cartCost), 'cart:pay');
          // collapse to one column on mobile...
          if (self._shouldMakeRightColumnFillScreen()) {
            self._setColumnCss(1);
          }
        }
        self.show();
        $(document.body).addClass('fmcy-showing-footer-controlbar');
      } else if (self.options._appChannel.request('active:view:check', 'challengeCart')) { 
          self.hide();
          $(document.body).removeClass('fmcy-showing-footer-controlbar');
      }else {
        var viewShowCheckout = true;
        if (self.options._appChannel.request('active:view:check', 'sidebar') || !self.options._appChannel.request('active:view:check', 'locationselectmap')) {
          viewShowCheckout = false;
        }
        if (self.options._appChannel.request('cart:get:items:count') > 0 && !viewShowCheckout) {
          self._renderShoppingCartIndicator();
          self._renderCheckoutActionButton();
          self.show();
          $(document.body).addClass('fmcy-showing-footer-controlbar');
        } else {
          self.hide();
          $(document.body).removeClass('fmcy-showing-footer-controlbar');
        }
      }
    },
    onRender: function () {
      var self = this;
      if (this.options.theme == 'dark') {
        this.$el.addClass('fmy-footer-bar-dark-theme');
      }
      this.listenTo(this.options._appChannel, 'active:view:updated', function (activeViews) {
        self._updateDisplayState();
      });
      this.listenTo(this.options._appChannel, 'cart:items:updated', function () {
          self._updateDisplayState();
      });
      self._updateDisplayState();
    }
});
module.exports = FooterControlBar;



/** WEBPACK FOOTER **
 ** ./assets/js/common/footer-control-bar.js
 **/